import React, {useMemo} from 'react';
import {Table, Button, Dropdown, Input, Checkbox, Icon, Popup} from 'semantic-ui-react';
import {useTable, usePagination, useFilters} from 'react-table';
import {invoicesPageSizes} from '../../../common/constants/lists';
import {Filter, DefaultColumnFilter} from './vehiclesTableFilters';

const VehiclesTable = ({tableColumns, tableData, selection}) => {
  const data = useMemo(() => tableData, [tableData]);
  const columns = useMemo(() => tableColumns, []);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    'state': {pageIndex, pageSize},
  } = useTable(
    {
      columns,
      data,
      'defaultColumn': {'Filter': DefaultColumnFilter},
      'initialState': {'pageIndex': 0, 'pageSize': 10},
      'autoResetFilters': false,
      'autoResetPage': false,
    },
    useFilters,
    usePagination,
    (hooks) => {
      hooks.visibleColumns.push((columns) => [
        // Let's make a column for selection
        {
          'id': 'processCheckBox',
          'Header': '',
          'width': 1,
          'defaultCanFilter': true,
          'Cell': ({row}) => {
            return (
              <div style={{'textAlign': 'center'}}>
                {
                  !selection.disableCheck(row.original) ?
                    <Checkbox checked={row.original.checked}
                      onChange={() => selection.handleChangeCheck(row.original)} /> :
                    <Popup trigger={<Icon name='lock' size='large' className='lock' color='yellow' />}
                      content={<>
                        <div>Reserva realizada</div>
                        <div>Transferencia: {row.original.transfer}</div>
                      </>} />
                }
              </div>
            );
          },
          'Filter': (item) => {
            return (
              <Checkbox disabled={selection.disableCheckAllFilter(item.filteredRows)}
                checked={selection.allCheckFilterValue(item.filteredRows)}
                onChange={(e, i) => selection.handleFilterCheckAll(i, item.filteredRows)}
              />
            );
          },
        },
        ...columns,
      ]);
    },
  );

  return (
    <>
      <div style={{'overflow': 'auto'}}>
        <Table width='13' className='interactive' compact striped {...getTableProps()}>
          <Table.Header>
            {headerGroups.map((headerGroup) => (
              <Table.Row key='headers' {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, index) => (
                  <Table.HeaderCell
                    key={`title-${index}`}
                    textAlign='center'
                    {...column.getHeaderProps()}
                  >
                    {column.render('Header')}
                  </Table.HeaderCell>
                ))}
              </Table.Row>
            ))}
            {headerGroups.map((headerGroup) => (
              <Table.Row key='filters' id='filters'>
                {headerGroup.headers.map((column, index) => (
                  <Table.HeaderCell
                    key={`filter-${index}`}
                    className={index === 3 || index === 6 ? 'dropdown-header' : ''}
                    textAlign='center'
                  >
                    {<Filter column={column} />}
                  </Table.HeaderCell>
                ))}
              </Table.Row>
            ))}
          </Table.Header>
          <Table.Body {...getTableBodyProps()}>
            {!page.length && (
              <Table.Row>
                <Table.Cell colSpan={14} textAlign='center'>
                  No hay datos disponibles
                </Table.Cell>
              </Table.Row>
            )}
            {page.length > 0 &&
              page.map((row, i) => {
                prepareRow(row);
                return (
                  <Table.Row key={i} {...row.getRowProps()}>
                    {row.cells.map((cell) => {
                      return (
                        <Table.Cell textAlign='center' {...cell.getCellProps()}>
                          {cell.render('Cell')}
                        </Table.Cell>
                      );
                    })}
                  </Table.Row>
                );
              })}
          </Table.Body>
        </Table>
      </div>
      <div className='flex middle center mt-1'>
        {page.length > 0 && (
          <Table.Footer fullWidth>
            <Table.Row>
              <Table.HeaderCell colSpan='5' textAlign='left'>
                <Button
                  className='navigation-button'
                  onClick={() => previousPage()}
                  disabled={!canPreviousPage}
                  content='Anterior'
                />
              </Table.HeaderCell>
              <Table.HeaderCell textAlign='right'>
                <span>páginas </span>
                <span>
                  <Input
                    className='pages-input'
                    type='number'
                    value={pageIndex + 1}
                    min='1'
                    max={pageOptions.length}
                    onChange={(e, {value}) => {
                      const page = value ? Number(value) - 1 : 0;
                      if (page < 1 || page > pageOptions.length) {
                        e.target.value = 1;
                      }
                      gotoPage(page);
                    }}
                  />
                </span>{' '}
                <span>de {pageOptions.length}</span>
              </Table.HeaderCell>
              <Table.HeaderCell textAlign='left'>
                <Dropdown
                  className='page-sizes-selection'
                  selection
                  upward
                  compact
                  value={pageSize}
                  options={invoicesPageSizes}
                  onChange={(e, {value}) => {
                    setPageSize(Number(value));
                  }}
                />
                <span>filas</span>
              </Table.HeaderCell>
              <Table.HeaderCell colSpan='4' textAlign='right'>
                <Button
                  className='navigation-button'
                  onClick={() => nextPage()}
                  disabled={!canNextPage}
                  content='Siguiente'
                />
              </Table.HeaderCell>
            </Table.Row>
          </Table.Footer>
        )}
      </div>
    </>
  );
};

export default VehiclesTable;
